import React from 'react'
import Spinner from 'icons/Spinner'

export const Button = ({ onClick, isLoading, style, children, spinnerStyle, ...rest }) => {
  const internalOnClick = (...args) => {
    // this function is not working, isLoading is never true despite props getting updated
    // cannot figure out why, tried wrapping in useCallback with isLoading as a dependency
    // nothing seems to work
    if (isLoading) {
      return
    }
    onClick && onClick(...args)
  }

  return (
    <button style={style} className='btn' {...rest} onClick={internalOnClick}>
      {isLoading ? <Spinner size='14px' style={{ ...spinnerStyle }} /> : children}
    </button>
  )
}
